var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"component"},[_c('span',{staticClass:"message"},[_vm._v("Application has been updated. Please refresh to update.")]),_vm._v(" "),_c('button',{attrs:{"type":"button"},on:{"click":_vm.reload}},[_vm._v("Reload")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-152d1935","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OutOfDateMessage.vue
// module id = null
// module chunks = 